/* eslint-disable camelcase */
import scanlineMapUtils from '../../../../../mapUtils';
import { deriveDataSetsFromProps } from './_BASE';

const isDefined = v => v !== undefined && v !== null;

export const createDerivedSurveys = (
  parentSurvey,
	processedReadings,
	processedReadingsWithChartGaps,
	processedReadingsWithGeoGaps,
	type,
	surveyReadings,
	jobId,
	meta,
	end_date,
	parent_survey_subtype,
  job_number
) => {
	const readings = {};
	const readingsWithChartGaps = {};
	const readingsWithGeoGaps = {};
	const readingsMap = {};
	const readingsIndexMap = {};
	const readingsWithChartGapsIndexMap = {};
	const readingsWithGeoGapsIndexMap = {};

	const series = {};
	const seriesIndexMap = {};
	const readingsStationIdIntegers = {};

	const readingsMeta = {};
	const surveys = [];
  const { s3Key } = meta || {};

  const xMin = surveyReadings[0].id;
  const xMax = surveyReadings[surveyReadings.length - 1].id;

  const survey = scanlineMapUtils.createSurveyTemplate(type, 'ILI-exMtlLoss', {
    parentSurvey,
		primaryXAxis: {
			minimum: xMin,
			maximum: xMax
		},
		jobId,
		s3Key,
		end_date,
		parent_survey_subtype,
		job_number
  });
  survey.xMin = survey.xMin || xMin;
  survey.xMax = survey.xMax || xMax;
	scanlineMapUtils.initSurveyMeta(survey);
	survey.isDerived = false; // we treat ILI sub charts as primary charts.
	const readingKeyProps = survey.meta.getReadingKeyProps();
  const isValidReading = (r) => (r && r?.anomaly && /EXT\sML/gi.test(r.anomaly) && isDefined(r?.gRate));

  const EMPTY_RESULTS = {
    readings,
    readingsWithChartGaps,
    readingsWithGeoGaps,
    readingsMap,
    readingsIndexMap,
    readingsWithChartGapsIndexMap,
    readingsWithGeoGapsIndexMap,
    readingsMeta,
    surveys,
    series,
    seriesIndexMap,
    readingsStationIdIntegers
  };

  if (!parent_survey_subtype === 'ILI') {
    return EMPTY_RESULTS;
  }

  const _processedReadings = processedReadings.filter(isValidReading);
  if (!_processedReadings.length) { 
    return EMPTY_RESULTS;
  }

  const _processedReadingsWithChartGaps = [..._processedReadings];
  const _processedReadingsWithGeoGaps = processedReadingsWithGeoGaps.filter(arr => {
    const valid = arr.filter(isValidReading);
    return valid.length ? valid : undefined;
  }).filter(v => v);

  survey.yMin = 0;
  processedReadings.forEach(r => {
    const curr = survey.yMax || 0;
    const val = r?.gRate || 0;
    survey.yMax = Math.max(curr, val);
  })

  if (processedReadings.filter(isValidReading).length) {  
		const {
			readings: thisReadings,
			readingsIndexMap: thisReadingsIndexMap,
			readingsMap: thisReadingsMap,
			readingsWithChartGaps: thisReadingsWithChartGaps,
			readingsWithChartGapsIndexMap: thisReadingsWithChartGapsIndexMap,
			readingsWithGeoGapsIndexMap: thisReadingsWithGeoGapsIndexMap,
			readingsWithGeoGaps: thisReadingsWithGeoGaps,
			series: thisSeries,
			seriesIndexMap: thisSeriesIndexMap,
			readingsStationIdIntegers: thisReadingsStationIdIntegers
		} = deriveDataSetsFromProps(
			survey,
			readingKeyProps,
			_processedReadings,
			_processedReadingsWithChartGaps,
			_processedReadingsWithGeoGaps,
			{ surveyMeta: survey.meta }
    );

    survey.checked = true;

    readings[survey.id] = thisReadings.filter(isValidReading);
		readingsWithChartGaps[survey.id] = thisReadingsWithChartGaps.filter(isValidReading);
		readingsWithGeoGaps[survey.id] = thisReadingsWithGeoGaps.map(arr => arr.filter(isValidReading));
		readingsIndexMap[survey.id] = thisReadingsIndexMap;
		readingsWithChartGapsIndexMap[
			survey.id
		] = thisReadingsWithChartGapsIndexMap;
		readingsWithGeoGapsIndexMap[survey.id] = thisReadingsWithGeoGapsIndexMap;
		readingsMap[survey.id] = thisReadingsMap;
		series[survey.id] = thisSeries;
		seriesIndexMap[survey.id] = thisSeriesIndexMap;
		readingsMeta[survey.id] = meta;
		readingsStationIdIntegers[survey.id] = thisReadingsStationIdIntegers;

		surveys.push(survey);
	}

	return {
		readings,
		readingsWithChartGaps,
		readingsWithGeoGaps,
		readingsMap,
		readingsIndexMap,
		readingsWithChartGapsIndexMap,
		readingsWithGeoGapsIndexMap,
		readingsMeta,
		surveys,
		series,
		seriesIndexMap,
		readingsStationIdIntegers
	};
};

export default { createDerivedSurveys };
